import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBoxArchive, faCircleDown, faCircleUp, faClipboardCheck, faShareNodes, faTrash, faEllipsisVertical, } from '@fortawesome/free-solid-svg-icons';
import { Modal } from '../UI/Modal';
import { Code } from '../UI/Code';
import { CardSkeleton } from '../UI/CardSkeleton';
import { configService } from '../../services/config.service';
import { useClickOutside } from '../../hooks/ui';
const { playServer } = await configService.appConfig;
export const QuizListItem = ({ quiz, onStatusUpdate, onDelete, }) => {
    const optionsRef = useRef(null);
    const [isOptionsOpen, setIsOptionsOpen] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [copied, setCopied] = useState(false);
    // Use custom hook for options menu
    useClickOutside(optionsRef, () => {
        if (isOptionsOpen)
            setIsOptionsOpen(false);
    });
    const handleCodeCopy = () => {
        setCopied(true);
    };
    const handleModalOpen = (event) => {
        event.preventDefault();
        setIsModalOpen(true);
        setCopied(false);
    };
    const handleModalClose = () => {
        setIsModalOpen(false);
    };
    const handleSubmissionsClick = (event) => {
        event.preventDefault();
        window.location.href = `/quizzes/${quiz.quizId}/submissions`;
    };
    const handleStatusUpdate = (event) => {
        event.preventDefault();
        onStatusUpdate(quiz.quizId, quiz.status === 'draft' ? 'published' : 'draft');
    };
    const handleDelete = (event) => {
        event.preventDefault();
        onDelete(quiz.quizId);
    };
    return quiz.loading ? (React.createElement(CardSkeleton, { kreeda: quiz })) : (React.createElement(React.Fragment, null,
        quiz.code && (React.createElement(Modal, { id: quiz.code, component: Code, componentProps: {
                id: quiz.code,
                link: `${playServer}?code=${quiz.code}`,
                copied,
                onCopy: handleCodeCopy,
            }, isOpen: isModalOpen, onClose: handleModalClose })),
        React.createElement(Link, { className: "activity-item", to: `/quizzes/${quiz.quizId}` },
            React.createElement("div", { className: "activity-header" },
                React.createElement("h3", null, quiz.name),
                React.createElement("div", { ref: optionsRef, className: "options-container" },
                    React.createElement("button", { className: "options-button", onClick: (event) => {
                            event.preventDefault();
                            setIsOptionsOpen(!isOptionsOpen);
                        } },
                        React.createElement(FontAwesomeIcon, { icon: faEllipsisVertical })),
                    React.createElement("div", { className: `options-menu ${isOptionsOpen ? 'show' : ''}` },
                        React.createElement("button", { className: "btn--secondary", onClick: handleSubmissionsClick },
                            React.createElement(FontAwesomeIcon, { icon: faClipboardCheck }),
                            "View Submissions"),
                        React.createElement("button", { className: "btn--secondary", onClick: (event) => {
                                event.preventDefault();
                            } },
                            React.createElement(FontAwesomeIcon, { icon: faBoxArchive }),
                            "Archive"),
                        React.createElement("button", { className: "btn--delete", disabled: quiz.status !== 'draft', onClick: handleDelete },
                            React.createElement(FontAwesomeIcon, { icon: faTrash }),
                            "Delete")))),
            React.createElement("div", { className: "activity-meta" },
                quiz.duration && (React.createElement(React.Fragment, null,
                    React.createElement("span", null,
                        parseInt(quiz.duration) / 60,
                        " min "))),
                React.createElement("span", null,
                    quiz.questionsCount,
                    " question(s)"),
                React.createElement("span", null,
                    quiz.submissionsCount,
                    " submission(s)")),
            React.createElement("div", { className: "activity-actions" },
                React.createElement("button", { className: "btn--primary publish", onClick: handleStatusUpdate, disabled: quiz.questionsCount === 0 },
                    React.createElement(FontAwesomeIcon, { icon: quiz.status === 'draft' ? faCircleUp : faCircleDown }),
                    quiz.status === 'draft' ? 'Publish' : 'Unpublish'),
                React.createElement("button", { className: "btn--secondary share", value: quiz.code, onClick: handleModalOpen, disabled: quiz.status === 'draft' },
                    React.createElement(FontAwesomeIcon, { icon: faShareNodes }),
                    "Host")))));
};
